import React from 'react'

export default function Error404() {
  return (
    <div className="styleDivError">
      <img className="styleError" alt="" src={require('../../media/404_error.jpg')} />
    </div>
  )
}
